import React from 'react';

const TrashIcon = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      {...props}
    >
      <path
        d="M1.625 3.25H2.70833H11.375"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2923 3.2487V10.832C10.2923 11.1193 10.1782 11.3949 9.97502 11.5981C9.77185 11.8012 9.4963 11.9154 9.20898 11.9154H3.79232C3.505 11.9154 3.22945 11.8012 3.02629 11.5981C2.82312 11.3949 2.70898 11.1193 2.70898 10.832V3.2487M4.33398 3.2487V2.16536C4.33398 1.87805 4.44812 1.6025 4.65129 1.39933C4.85445 1.19617 5.13 1.08203 5.41732 1.08203H7.58398C7.8713 1.08203 8.14685 1.19617 8.35002 1.39933C8.55318 1.6025 8.66732 1.87805 8.66732 2.16536V3.2487"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrashIcon;
